/**
 * @file Redux mappers for composeFooter container
 */

import { MapDispatchToProps, MapStateToProps } from 'react-redux';

import AppState from '../../../models/state';
import { clearDraftRequest } from '../../../store/actions/draftsMain';

import { DispatchProps, OwnProps, StateProps } from './types';

/**
 * Map Redux dispatch actions to component props
 *
 * @param dispatch          Redux dispatch function
 * @param ownProps          Props passed to the container
 * @param ownProps.nodeType The ID of the draft
 * @returns                 Mapped props
 */
export const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  { nodeType },
) => ({
  /**
   * Dispatches request to clear text draft
   *
   * @returns void
   */
  requestDraftClear: () => dispatch(clearDraftRequest(nodeType)),
});

/**
 * Map Redux state to container props
 *
 * @param appState          App state
 * @param appState.drafts   Drafts data
 * @param ownProps          Props passed to the container
 * @param ownProps.nodeType Draft ID
 * @returns                 Mapped props
 */
export const mapStateToProps: MapStateToProps<
  StateProps,
  OwnProps,
  AppState
> = ({ drafts }, { nodeType }) => {
  const draft = drafts.get(nodeType);

  if (draft === undefined) {
    return {
      checklist: [],
      labels: [],
      nodeId: null,
      status: null,
      text: '',
    };
  }

  return {
    checklist: draft.checklistSaved.map(({ text }) => text).sort(),
    labels: [...draft.labelsSaved].sort(),
    nodeId: draft.nodeId,
    status: draft.status,
    text: draft.text,
  };
};
